import {ERROR_MESSAGE} from "../sagas/notifications";

const initialState = {
  notifications: [],
};

export function notifications(state = initialState, action) {
  const {type, error} = action;
  const matches = new RegExp(".*(\\.|_)FAILURE").exec(type);
  // a 404 is a failure but we don't want to display an error message in that case.
  if (matches && error && error.status !== 404 && !(error.status == 400 && error.content)) {
    return {
      ...state,
      notifications:[{message:error.code || "error.generic", type: ERROR_MESSAGE}],
    };
  }
  switch (action.type) {
  case 'ADD_NOTIFICATION':
      return {
        ...state,
        notifications:[action.notification],
      };
      case 'REMOVE_NOTIFICATION':
      const filtered = state.notifications.filter(n=>n.id !== action.notification.id);
      return {
        ...state,
        notifications: filtered,
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notifications.js